var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 523,
    viewBox: "0 0 512 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.674 295.487H288.329C288.329 332.627 263.569 345.449 251.189 347.218C250.186 408.408 281.442 453.496 314.711 482.513M413.674 295.487H439.542C440.426 311.183 450.153 343.504 481.987 347.218C473.144 391.211 438.215 486.758 369.241 517C354.445 511.032 334.231 499.539 314.711 482.513M413.674 295.487V71.3212M413.674 71.3212L347.352 5M413.674 71.3212H347.352V5M347.352 5H31V482.513H314.711M114.565 113.767H188.181M114.565 158.865H330.772M114.565 203.964H330.772M114.565 246.409H330.772",
    stroke: "#4487C5",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.924 400.938C381.675 400.938 394.443 388.17 394.443 372.42C394.443 356.669 381.675 343.901 365.924 343.901C350.174 343.901 337.406 356.669 337.406 372.42C337.406 388.17 350.174 400.938 365.924 400.938ZM365.924 400.938V431.445",
    stroke: "#4487C5",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestProtection);
export default __webpack_public_path__ + "static/media/request-protection.64726cd2f657afdaa2c3f555baf5a5eb.svg";
export { ForwardRef as ReactComponent };